/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/adiraparty/"

const adiraParty: CommunityData = {
  code: "adiraparty",
  inviteCode: "adiraparty",
  name: "ADIRA Party",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/adi-963`,
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#cd1b1b",
      hero: {
        desktop: `${S3_PREFIX}web-background-v2.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-v2.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[92px] h-[48px] sm:w-[180px] sm:h-[94px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['MenaGroteskBold'] text-[28px] leading-[120%] text-[#ffffff]",
      text: "font-['CourierPrimeRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['RobotoRegular'] text-[16px] leading-[120%] uppercase p-4 bg-[#e8178a] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['CourierPrimeRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#8b1212] text-[#ffffff]",
        border: "#ffffff40",
        borderFocus: "#ffffff80",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['CourierPrimeRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['CourierPrimeRegular'] text-[14px] leading-[120%] text-[#ffffff80]",
      skipButton:
        "font-['CourierPrimeRegular'] text-[14px] leading-[120%] text-[#ffffff80] cursor-pointer",
      modal: {
        container: "bg-[#8b1212] px-[40px] py-[48px]",
        title: "font-['MenaGroteskBold'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['CourierPrimeRegular'] text-[14px] leading-[120%] text-[#ffffff80] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#cd1b1b] font-['CourierPrimeRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#ffffff40",
        otpBorderFocus: "#ffffff80",
      },
    },
    global: {
      counterColor: "#FFF",
      werzLogoColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[180px] h-[94px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[180px] h-[94px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#cd1b1b",
      asideBg: "#cd1b1b",
      asideStyles: "",
      contentBg: "#cd1b1b",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background-v2.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-v2.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-v2.mp4?type=video`,
      mainFont: "font-['CourierPrimeRegular']",
      primaryButton:
        "bg-[#e8178a]  px-[18px] py-[18px] !text-[#ffffff] font-['RobotoRegular'] !text-[16px] uppercase text-left leading-[120%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff40]",
      separator: "border-[#ffffff40]",
      item: "font-['MenaGroteskMedium'] text-[16px] text-[#ffffff] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#ffffff40] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#cd1b1b] border border-[#ffffff40] !pb-8",
      titles: "text-[#ffffff] font-['MenaGroteskBold'] text-[28px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#eaff06] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff40]",
        sectionTitle:
          "text-[#ffffff] font-['MenaGroteskBold'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#cd1b1b]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['MenaGroteskBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#eaff06] font-['CourierPrimeRegular'] text-[12px] text-left leading-[110%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff40]",
        sectionTitle:
          "text-[#ffffff] font-['MenaGroteskBold'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#cd1b1b]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['MenaGroteskBold'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#eaff06] font-['CourierPrimeRegular'] text-[12px] text-left leading-[110%] mt-2",
          location:
            "text-[#eaff06] font-['CourierPrimeRegular'] text-[12px] text-left leading-[110%] mt-1",
          date: "text-[#eaff06] font-['CourierPrimeRegular'] text-[12px] text-left leading-[110%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['MenaGroteskBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['CourierPrimeRegular'] text-[16px] text-left leading-[110%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['MenaGroteskBold'] text-[28px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#cd1b1b] border border-[#ffffff40] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ffffff40]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#ffffff] font-['MenaGroteskBold'] text-[28px] text-left leading-[110%]",
        subtitle:
          "text-[#eaff06] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%] mb-4 mt-2",
        button:
          "bg-[#e8178a]  px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['RobotoRegular'] !text-[16px] uppercase text-left leading-[120%]",
        questions: "text-[14px] text-left leading-[110%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff40]",
        header: "text-[#ffffff] font-['MenaGroteskBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff40]",
        header: "text-[#ffffff] font-['MenaGroteskBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['MenaGroteskBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['MenaGroteskBold'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#cd1b1b] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff00] border border-[#eaff06] px-[16px] py-[16px] text-[#eaff06] font-['RobotoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#cd1b1b] border-b border-[#ffffff40] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['MenaGroteskBold'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#eaff06] font-['CourierPrimeRegular'] text-[14px] text-left leading-[110%] mb-1 flex flex-row",
          price: "text-[#eaff06] font-['MenaGroteskBold'] text-[16px] text-left leading-[110%]",
          quantity:
            "text-[#eaff06] font-['RobotoRegular'] text-[14px] uppercase text-left leading-[100%]",
          status: "text-[#eaff06] font-['MenaGroteskBold'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff00] border border-[#eaff06] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff00] border border-[#eaff06] px-[16px] py-[16px] text-[#eaff06] font-['RobotoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#eaff06",
        },
      },
    },
  },
}

export default adiraParty
